<script>
import imageService from "@/services/image";

export default {
  name: "ImagesSelect",
  props: {
    value: { type: String, default: "" },
    readonly: { type: Boolean, default: false },
    isDisabled: { type: Boolean, default: false },
  },

  data() {
    return {
      categories: [],
      images: [],
      filteredImages: [],
      isLoading: false,
      catalog: [],
      filterValue: "",
      selectedCategory: null,
    };
  },

  computed: {
    findImageById() {
      const image = this.images.find((img) => img._id === this.value);
      return image ? image.description : "Sin datos";
    },
  },

  methods: {
    async loadCatalog() {
      this.isLoading = true;
      try {
        const categories = await imageService.getCategories();

        this.categories = categories.sort((a, b) => {
          const nameA = a.toLowerCase();
          const nameB = b.toLowerCase();

          if (nameA.includes("otros") && !nameB.includes("otros")) return 1;
          if (!nameA.includes("otros") && nameB.includes("otros")) return -1;

          return nameA.localeCompare(nameB);
        });

        this.catalog = await imageService.getImages();
        this.images = [...this.catalog];
        this.filteredImages = [...this.images];
      } catch (error) {
        console.error("Error loading images:", error);
        this.categories = [];
        this.catalog = [];
        this.images = [];
        this.filteredImages = [];
      } finally {
        this.isLoading = false;
      }
    },

    async loadImagesByCategory(category) {
      this.isLoading = true;
      try {
        if (category && category !== "") {
          this.filteredImages = await imageService.getImages("", category);
        } else {
          this.filteredImages = [...this.images];
        }
      } catch (error) {
        console.error("Error loading images by category:", error);
        this.filteredImages = [];
      } finally {
        this.isLoading = false;
      }
    },

    /**
     * @description Pre-filtra el selector de imágenes con el término sugerido por la IA.
     *              El médico confirma el estudio exacto de la lista filtrada.
     * @param {string} term - Nombre del estudio sugerido por la IA
     */
    triggerAISearch(term) {
      if (!term) return;
      this.filterImages(term);
    },

    filterImages(filterValue) {
      this.filterValue = filterValue;
      if (!filterValue) {
        if (this.selectedCategory) {
          this.filterImagesByCategory();
        } else {
          this.filteredImages = [...this.images];
        }
      } else {
        const baseImages = this.selectedCategory
          ? this.filteredImages
          : this.images;
        this.filteredImages = baseImages.filter((img) =>
          img.description.toLowerCase().includes(filterValue.toLowerCase())
        );
      }
    },

    async filterImagesByCategory() {
      await this.loadImagesByCategory(this.selectedCategory);
      // Limpiar el campo de imagen solo si tenía información previa
      if (this.value) {
        this.$emit("input", "");
      }
    },

    onInput(value) {
      const selected =
        this.filteredImages.find((m) => m._id === value) ||
        this.catalog.find((m) => m._id === value);
      if (selected && !this.$store.state.cacheImages?.[value]) {
        this.$store.dispatch("addImages", selected);
      }
      this.$emit("input", value);
    },
  },

  created() {
    this.loadCatalog();
  },
};
</script>

<template lang="pug">
div
  label.label Categoría
  el-select(
    v-model="selectedCategory"
    filterable
    placeholder="Seleccionar categoría"
    :disabled="isDisabled"
    @change="filterImagesByCategory"
    :loading="isLoading"
    clearable
  )
    el-option(v-for="category in categories" :key="category" :label="category" :value="category")

  template(v-if="!readonly")
    label.label Imagen
    el-select(
      :value="value"
      @input="onInput"
      filterable
      :filter-method="filterImages"
      :loading="isLoading"
      :disabled="isDisabled"
      placeholder="Seleccionar imágen"
    )
      el-option(
        v-for="item in filteredImages"
        :key="item._id"
        :label="item.description"
        :value="item._id"
      )
        span(style="float: left") {{ item.category + " - " + item.description }}

  el-input(v-else :value="findImageById" readonly :disabled="isDisabled")
</template>

<style scoped>
.label {
  font-weight: 600;
  margin-right: 8px;
}
</style>
